export default __webpack_public_path__ + "static/media/new-main-logo.c847e7f5.png";